export class Tenant {
  id: number;
  uuid: string;
  name: string;
  isAvailable: boolean;
  storeOwner: number;
}
